<template>
  <div>
    <div class="flexhere">
      <div>
        <i class="far fas fa-home fa-1x icon"></i>
        <a href="#start" class="a">Home</a>
      </div>
      <div>
        <i class="far fa-id-badge fa-1x icon"></i>
        <a href="#secondslide" class="a">&nbsp;About</a>
      </div>
      <div>
        <i class="far fa-address-card fa-1x icon"></i>
        <a href="#thirdslide" class="a">Skills</a>
      </div>
      <div>
        <i class="fas fa-tasks fa-1x icon"></i>
        <a href="#fourthslide" class="a">Projects</a>
      </div>
      <div>
        <i class="fas fa-handshake fa-1x icon"></i>
        <a href="#fifthslide" class="a">Experience</a>
      </div>
      <div>
        <i class="fas fa-medal fa-1x icon"></i>
        <a href="#sixthslide" class="a">Achievements</a>
      </div>
      <div>
        <i class="fas fa-phone fa-1x icon"></i>
        <a href="#seventhslide" class="a">Contact</a>
      </div>
      <div
        class="copyright"
        style="margin-top:1vh;color:white;margin-left:10px;"
      >
        © Copyright 2021
        <a
          href="mailto:devulapallisaiprachodhan26@gmail.com?subject=&body=Hello Prachodhan,"
          style="text-decoration:none;color:skyblue;white-space:pre"
          >Sai Prachodhan</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Links",
};
</script>

<style scoped>
* {
  scroll-behavior: smooth;
  color: rgba(255, 255, 255, 0.705);
}
.icon {
  margin-right: 1.5vw;
  font-size: 22px;
  margin-left: 1vw;
  color: rgb(255, 255, 255);
}
.a {
  list-style: none;
  text-decoration: none;
  font-size: 3vh;
  color: rgba(255, 255, 255, 0.705);
  color: white;
  /* color: inherit; */
  font-family: "Roboto", Arial, Helvetica, sans-serif;
}
.a:hover {
  color: rgb(226, 183, 74);
  cursor: pointer;
}
.flexhere {
  height: 59.4vh;
  margin-top: 2vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.copyright {
  font-family: Helvetica, sans-serif;
  font-size: 2.8vh;
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .copyright {
    display: none;
  }
  .flexhere {
    margin-left: 4vw;
    height: 50vh;
  }
}
@media screen and (min-height: 1300px) and (max-height: 2000px) {
  .copyright {
    display: none;
  }
  .flexhere {
    margin-left: 4vw;
    height: 50vh;
  }
  .icon {
    margin-right: 2.5vw;
    font-size: 3vh;
    margin-left: 1vw;
    color: rgb(255, 255, 255);
  }
}
</style>
